import React from 'react';
import { Package, DollarSign, Users } from 'lucide-react';

interface BottomNavProps {
  active: string;
  onSelect: (key: string) => void;
  navItems?: { key: string; label: string; icon: React.ComponentType<any> }[];
}

const DEFAULT_NAV_ITEMS = [
  { key: 'products', label: 'Productos', icon: Package },
  { key: 'sales', label: 'Ventas', icon: DollarSign },
];

export default function BottomNav({ active, onSelect, navItems }: BottomNavProps) {
  const items = navItems || DEFAULT_NAV_ITEMS;
  return (
    <nav className="bottom-nav">
      {items.map(item => {
        const IconComponent = item.icon;
        return (
          <button
            key={item.key}
            className={`bottom-nav-item${active === item.key ? ' active' : ''}`}
            onClick={() => onSelect(item.key)}
          >
            <IconComponent className="bottom-nav-icon" size={24} />
            <span className="bottom-nav-label">{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
} 